<script setup lang="ts">

import { formatDecimal } from '@/application/utils/money';

interface Props {
  hasContracts: boolean;
  contractsCount: number;
  totalCostPerMonth: number;
}

defineProps<Props>();
</script>

<template>
  <div class="flex gap-3">
    <span v-if="!hasContracts" class="text-xs md:text-sm px-4 text-gray-500">Es liegen zur Zeit keine Verträge von Ihnen vor.</span>
    <span v-if="hasContracts" class="text-xs md:text-sm text-gray-800">
      <span class="pr-2">Aktive Verträge</span>
      <span
        class="font-medium inline-flex items-center rounded-md bg-white px-2 py-1 text-xs md:text-sm text-gray-700
        ring-1 ring-inset ring-gray-200"
      >
        {{ contractsCount }}
      </span>
    </span>
    <span v-if="hasContracts" class="text-xs md:text-sm text-gray-800">
      <span class="pr-2">monatliche Kosten</span>
      <span
        class="font-medium inline-flex items-center rounded-md bg-white px-2 py-1 text-xs md:text-sm text-gray-700
         ring-1 ring-inset ring-gray-200"
      >
        {{ formatDecimal(totalCostPerMonth) }}
      </span>
    </span>
  </div>
</template>
